import GameConfig from "../core/data/GameConfig";
import PlayerData from "../PlayerData"
import { ItemData } from "../scenes/ShopScene";

export class PlayerDataUtils {
    static CanUnlockFirstCharacter(): boolean {
        const saveData = PlayerData.Instance.saveData;
        const charactersUnlocked = saveData.charactersUnlocked
        const newCharacterSelected = saveData.newCharacterSelected;

        // checking if newCharacterSelected is undefined as older versions of save data didn't have it
        return charactersUnlocked > 0 && (newCharacterSelected == false || newCharacterSelected == undefined)
    }

    static PlayerCanBuyFirstItem(): boolean {
        const saveData = PlayerData.Instance.saveData;
        const boughtItem = saveData.boughtItem;
        let canAffordUpgrade = false;
		const items = ["rubberBand", "grease", "anvil", "detonator", "steelBall"];
		for (let i = 0; i < 5; i++) {
			const itemName = items[i];
			const data = GameConfig.get<any>("items")[itemName] as ItemData;
			const level = saveData.items[itemName];
			if (level >= data.price.length) continue;
			const price = data.price[level];
			if (saveData.coins >= price) canAffordUpgrade = true;
		}
        return !boughtItem && canAffordUpgrade;
    }
}